import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "m-6 text-gray-800" }
const _hoisted_4 = { class: "font-bold text-3xl" }
const _hoisted_5 = {
  key: 0,
  class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8"
}
const _hoisted_6 = { class: "flex border-t border-b border-gray-200" }
const _hoisted_7 = { class: "w-full flex mx-auto px-6 space-x-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_9 = {
  href: "javascript:void(0)",
  class: "text-gray-400 hover:text-gray-500"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Home", -1)
const _hoisted_11 = {
  key: 1,
  class: "flex items-center text-sm text-gray-500 font-medium"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "flex-shrink-0 w-6 h-full text-gray-200",
  viewBox: "0 0 24 44",
  preserveAspectRatio: "none",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" })
], -1)


import { useRoute } from "vue-router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  props: { title: String, createPlayerButton: Boolean },
  setup(__props) {

const HomeIcon = require("@heroicons/vue/solid/HomeIcon");

const route = useRoute();
const store = useStore();



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.title), 1)
      ]),
      (__props.createPlayerButton && _unref(store).state.user.permissions.includes('USER.CREATE'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("button", {
              type: "button",
              style: {"height":"30px"},
              class: "h-[30px] ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickCreatePlayer')))
            }, " Create New Player ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("nav", _hoisted_6, [
      _createElementVNode("ol", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(route).matched, (page, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "flex",
            key: index
          }, [
            (page.name === 'Home')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("a", _hoisted_9, [
                    _createVNode(_unref(HomeIcon), {
                      class: "flex-shrink-0 h-5 w-5",
                      "aria-hidden": "true"
                    }),
                    _hoisted_10
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_router_link, {
                    class: "ml-4 hover:text-gray-700",
                    to: { to: page.name }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(page.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]))
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})